// internationalization
import { useTranslation } from 'react-i18next';

// material ui icons
import LanRoundedIcon from '@mui/icons-material/LanRounded';

// material ui
import { alpha } from '@mui/material';
import { blue } from '@mui/material/colors';

// relative
import EnergyXplorerBaseCard from './EnergyXplorerBaseCard';
const EnergyXplorerCard = ({ index = 0 }) => {
  const { t } = useTranslation('energy-analysis');
  const features = t('sales_cards.energyxplorer.features', {
    returnObjects: true,
  });
  const card = {
    title: t('sales_cards.energyxplorer.title'),
    subtitle: t('sales_cards.energyxplorer.subtitle'),
    description: t('sales_cards.energyxplorer.description'),
    icon: <LanRoundedIcon sx={{ fontSize: 40 }} />,
    color: blue[300],
    bgColor: alpha(blue[300], 0.1),
    features: Array.isArray(features) ? features : [],
    learnMoreLink: 'https://www.remoni.com/energyxplorer_energy_management/',
    contactLink: 'https://www.remoni.com/contact/',
    chip: null,
    supportedDataTypes: ['Power'],
  };

  return <EnergyXplorerBaseCard card={card} index={index} />;
};

export default EnergyXplorerCard;
